"use client";

import { useState, useRef } from "react";

export function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const email = inputRef.current?.value?.trim();
    if (!email) return;

    setStatus("loading");
    setErrorMsg("");

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Er ging iets mis.");
      }

      setStatus("success");

      // GA4 event
      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "newsletter_signup", {
          event_category: "engagement",
          event_label: "blog_newsletter",
        });
      }
    } catch (err) {
      setStatus("error");
      setErrorMsg(err instanceof Error ? err.message : "Er ging iets mis.");
    }
  }

  if (status === "success") {
    return (
      <div className="mt-16 rounded-2xl border border-green-500/20 bg-green-500/10 p-6 text-center">
        <p className="font-medium text-white">Je bent aangemeld!</p>
        <p className="mt-1 text-sm text-gray-400">Check je inbox voor een bevestigingsmail.</p>
      </div>
    );
  }

  return (
    <div className="mt-16 rounded-2xl border border-blue-500/20 bg-blue-500/10 p-6">
      <h3 className="mb-2 text-lg font-bold text-white">Wekelijks AI &amp; Sales inzichten</h3>
      <p className="mb-4 text-sm text-gray-400">
        Ontvang elke dinsdag praktische tips over AI-training en salesverbetering.
      </p>
      <form className="flex gap-2" onSubmit={handleSubmit}>
        <input
          ref={inputRef}
          type="email"
          placeholder="je@bedrijf.nl"
          required
          autoComplete="email"
          disabled={status === "loading"}
          className="flex-1 rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm text-white placeholder-gray-500 outline-none focus:border-blue-500/50 focus:ring-2 focus:ring-blue-500/25 disabled:opacity-50"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="rounded-xl bg-blue-500 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-600 focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:outline-none disabled:opacity-50"
        >
          {status === "loading" ? "Even geduld..." : "Aanmelden"}
        </button>
      </form>
      {status === "error" && (
        <p className="mt-2 text-sm text-red-400" role="alert">
          {errorMsg}
        </p>
      )}
      <p className="mt-2 text-[11px] text-gray-500">Geen spam. Max 1 mail per week.</p>
    </div>
  );
}
